export default {"src":"/_next/static/media/0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f.a00108f4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};